(() => {
  'use strict';
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(scope = document) {
    scope.querySelectorAll('[data-product-tabs]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const bar = root.querySelector('.cz-tab-buttons'), buttons = [...bar.querySelectorAll('[data-tab]')], panels = [...root.querySelectorAll('[data-panel]')];
      bar.hidden = false; bar.setAttribute('role', 'tablist');
      function select(button, focus = false) {
        buttons.forEach(b => { const active = b === button; b.setAttribute('aria-selected', String(active)); b.tabIndex = active ? 0 : -1; });
        panels.forEach(p => { p.hidden = p.dataset.panel !== button.dataset.tab; });
        if (focus) button.focus();
      }
      buttons.forEach((b, i) => {
        b.setAttribute('role', 'tab');
        b.addEventListener('click', () => select(b));
        b.addEventListener('keydown', e => {
          let next;
          if (e.key === 'ArrowRight') next = (i + 1) % buttons.length;
          if (e.key === 'ArrowLeft') next = (i + buttons.length - 1) % buttons.length;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = buttons.length - 1;
          if (next !== undefined) { e.preventDefault(); select(buttons[next], true); }
        });
      });
      panels.forEach(p => { p.setAttribute('role','tabpanel'); p.setAttribute('aria-labelledby', buttons.find(b => b.dataset.tab === p.dataset.panel).id); p.tabIndex = 0; });
      select(buttons[0]);
    });
    scope.querySelectorAll('[data-review-carousel]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const track = root.querySelector('.cz-review-grid'), cards = [...track.querySelectorAll('.cz-review')], prev = root.querySelector('[data-review-prev]'), next = root.querySelector('[data-review-next]'), status = root.querySelector('[data-review-position]');
      if (!cards.length) return;
      function update() {
        const size = cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
        const start = Math.round(track.scrollLeft / size), visible = Math.max(1, Math.round((track.clientWidth + 20) / size));
        const scrollable = track.scrollWidth > track.clientWidth + 2;
        prev.hidden = next.hidden = !scrollable;
        prev.disabled = track.scrollLeft < 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        status.textContent = `${status.dataset.label} ${start + 1}–${Math.min(cards.length, start + visible)} / ${cards.length}`;
      }
      function move(direction) {
        const size = cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
        track.scrollBy({left:direction * size, behavior:reduced() ? 'instant' : 'smooth'});
      }
      prev.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, {passive:true});
      const observer = new ResizeObserver(update); observer.observe(track); update();
      root.addEventListener('shopify:block:select', e => { e.target.scrollIntoView({behavior:'instant',block:'nearest',inline:'nearest'}); });
    });
    scope.querySelectorAll('[data-product]').forEach(root => {
      const update = () => {
        const option = root.querySelector('[data-variant-select]')?.selectedOptions[0], note = root.querySelector('[data-loyalty-rate]'), price = root.querySelector('[data-product-price]');
        if (note && option) {
          const qty = Math.max(1, Number(root.querySelector('[name=quantity]')?.value) || 1);
          note.querySelector('[data-loyalty-points]').textContent = Math.floor(Number(option.dataset.priceCents) * Number(note.dataset.loyaltyRate) * qty / 100);
        }
        price?.classList.toggle('is-sale', Boolean(option?.dataset.compare));
        if (root.dataset.requiresPlan === 'true') root.querySelector('[data-product-submit]').disabled = true;
      };
      if (!root.dataset.enhanced) { root.dataset.enhanced = 'true'; root.addEventListener('change', update); root.addEventListener('input', update); }
      update();
    });
    scope.querySelectorAll('[data-product-share]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const status = root.querySelector('[data-share-status]'), fallback = root.querySelector('[data-share-fallback]');
      async function copy() {
        try { await Promise.race([navigator.clipboard.writeText(root.dataset.shareUrl), new Promise((_, reject) => setTimeout(() => reject(new Error('Clipboard timeout')), 1800))]); status.textContent = status.dataset.copied; fallback.hidden = true; }
        catch { fallback.hidden = false; fallback.focus(); fallback.select(); status.textContent = status.dataset.copyFailed; }
      }
      root.querySelector('[data-copy-link]').addEventListener('click', copy);
      const native = root.querySelector('[data-native-share]');
      if (navigator.share) { native.hidden = false; native.addEventListener('click', async () => { try { await navigator.share({title:root.dataset.shareTitle,url:root.dataset.shareUrl}); } catch(e) { if(e.name !== 'AbortError') await copy(); } }); }
    });
  }
  init(); document.addEventListener('shopify:section:load', e => init(e.target));
})();
